var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaintingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.836 62.378",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".painting_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "painting_icon_svg__a",
    d: "M62.736 4.393l-11.291 9.951L41.5 25.629a1 1 0 00.079 1.425l1.261 1.261a1.09 1.09 0 001.4.091l11.285-9.866 9.952-11.374a1.1 1.1 0 00-.079-1.5l-1.242-1.2a1.1 1.1 0 00-1.419-.079z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "painting_icon_svg__a",
    d: "M54.21 9.685H10.002a2.661 2.661 0 00-2.686 2.686v33.313a2.661 2.661 0 002.686 2.686h48.313a2.667 2.667 0 002.686-2.686V16.396M16 61l7.917-12.631M52.315 61l-7.917-12.631M10.476 2.973H6.524M8.497 1v3.946M4.946 7.699H1M2.973 5.738v3.946"
  }), /*#__PURE__*/React.createElement("path", {
    className: "painting_icon_svg__a",
    d: "M31.792 35.714l3.709-2.527a2.028 2.028 0 00.609-2.607l-.158-.238a1.011 1.011 0 01.865-1.5l2.436-.158a1.772 1.772 0 011.261.475l.317.238a1.632 1.632 0 01.4 1.577l-.4 1.181a5.414 5.414 0 01-4.732 3.477zM61 39.684H50.738a2.649 2.649 0 01-2.686-2.609v-3.548a2.722 2.722 0 00-3.946-2.29l-.475.213M30.232 37.87a2.655 2.655 0 01-3.787-2.369v-6.633a2.661 2.661 0 00-4.129-2.211l-15 9.787M16.792 21.134H16M29.423 21.134H18.369M38.107 17.973h.786M24.685 17.973h11.029"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaintingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/painting_icon.ca9f473cadba24aaebddb3762bb8d778.svg";